import React, { useMemo, useState } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { Layout, Breadcrumb, Avatar } from 'antd';
import { makeStyles } from '@material-ui/core';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import { formatDate } from 'src/helpers/millisecondsToFormattedDate';
import { useGetBox } from 'src/reactQuery/box/useGetBox';
import ArrowNextIcon from '../../../asset/arrow-next.svg';
import CButton from '../../../component/Button';
import Loader from '../../../component/Loader/Loader';

const useStyles = makeStyles({
  gridContainer: {
    display: 'grid',
    gridRowGap: '25px',
    gridTemplateColumns: '33% 33% 33%',
    marginLeft: '90px',
    marginTop: '55px'
  },
  gridHeader: {
    gridColumn: '33% 33% 33%',
    gridRow: '1',
    textAlign: 'start'
  },
  gridItem: {
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemPayment: {
    display: 'flex',
    flexDirection: 'column',
    gridColumn: '3',
    gridRow: '1 / span 2',
    height: '100%',
    justifyContent: 'space-between',
    maxWidth: '90%',
    textAlign: 'start'
  },
  gridItemSelect: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '90%',
    textAlign: 'start'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    marginTop: '12px'
  },
  probableAnswers: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr'
  },
  questionsContainer: {},
  selectHeader: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    margin: '0px'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  },
  usersInfo: {
    display: 'flex'
  }
});

const BoxDetail = () => {
  const history = useHistory();
  // @ts-ignore
  const { boxId } = useParams();
  const classes = useStyles();
  const { data: selectedBox, isLoading } = useGetBox(boxId);

  const [isEditModeOn, setIsEditModeOn] = useState<boolean>(false);

  function itemRender(route: Route, params: any, routes: Route[]) {
    const last = routes.indexOf(route) === routes.length - 1;

    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    );
  }

  const routes: Route[] = useMemo(() => {
    return [
      {
        breadcrumbName: 'Boxes',
        path: '/box'
      },
      {
        breadcrumbName: selectedBox?._id || '',
        path: `/box/${1}`
      }
    ];
  }, [selectedBox]);

  const onUpdate = () => {
    history.push('/box');
  };

  const SupplierHeader = () => {
    // need profilePictureUrl
    const { _id, createdAt } = selectedBox!;
    const finalDate = formatDate(createdAt);

    return (
      <div
        style={{
          display: 'flex'
        }}
      >
        <Avatar
          src={selectedBox?.metadata.image || '-'}
          style={{
            display: 'flex',
            height: '55px',
            width: '55px'
          }}
        />
        <div
          className={classes.gridContainer}
          style={{
            marginLeft: '35px',
            marginTop: '0px',
            width: '100%'
          }}
        >
          <div className={classes.gridHeader}>
            <span className={classes.span}>{selectedBox?.metadata.fullName || '-'}</span>
            <p className={classes.p}>
              ID: <span style={{ color: 'black' }}>{_id || '-'}</span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const OrderBody = () => {
    const { data } = selectedBox!;

    return (
      <div className={classes.gridContainer}>
        {data?.map((question, index) => {
          return (
            <div key={index} className={classes.gridItem}>
              <p>{question.questionDescription || '-'}</p>
              <div className={classes.gridItem}>
                <p className={classes.p}>Probable answers</p>
                <div className={classes.probableAnswers}>
                  {Object.values(question.probableAnswers).map((probableAnswer, index) => {
                    return <p key={index}>{probableAnswer}</p>;
                  })}
                </div>
              </div>
              <div className={classes.gridItem}>
                <p className={classes.p}>Correct answer</p>
                <div>{question.correctAnswer}</div>
              </div>
              <div className={classes.gridItem}>
                <p className={classes.p}>Selected answer</p>
                <div>{question.selectedAnswer}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Layout style={{ background: 'white' }}>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            justifyContent: 'flex-start'
          }}
        />
        <div>
          <CButton onClick={onUpdate} type="primary">
            Save
          </CButton>
          <CButton onClick={() => setIsEditModeOn(!isEditModeOn)} type="primary">
            {isEditModeOn ? 'Cancel' : 'Edit'}
          </CButton>
        </div>
      </div>
      <div style={{ marginTop: '55px', padding: '0px 40px 0px 35px' }}>
        <SupplierHeader />
        <OrderBody />
      </div>
    </Layout>
  );
};

export default BoxDetail;
